import React from "react"
import { Box } from "@mui/material"

interface RadiusCircleProps {
    pixelRadius: number;
    label: string;
}

type DirectionTuple = [number, string];

export default function RadiusCircle(props: RadiusCircleProps)  {
    const { pixelRadius, label } = props
    
      const FONTSIZE = 16;
      const fontShadow = `
        1px 1px 2px white, 
        -1px -1px 2px white, 
        1px -1px 2px white, 
        -1px 1px 2px white`;

    const generateLabel = (tuple: DirectionTuple) => {
        const [positionDeg, label] = tuple;
        const positionDegCoorected = (positionDeg as number + 270) % 360;
        return (<Box m={0} sx={{
            width: "100%"
            , height: `${FONTSIZE}px`
            , position: "absolute"
            , top: `${pixelRadius - (FONTSIZE / 2)}px`
            , transform: `rotate(${positionDegCoorected}deg)`
        }}>
            <Box m={0} sx={{
            position: "absolute"
            , right: 0
            , height: `${FONTSIZE}px`
            , marginRight: "-22px"
            , fontSize: FONTSIZE
            , textShadow: fontShadow
            , transform: `rotate(-${positionDegCoorected}deg)`
            }}>
            {label}
            </Box>
        </Box>);
    }

    return (
        <Box
      sx={{
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        pointerEvents: 'none',
      }}
    >
            <Box
                sx={{
                    width: `${pixelRadius * 2}px`,
                    height: `${pixelRadius * 2}px`,
                    border: 1,
                    borderColor: "black",
                    borderRadius: "50%",
                    zIndex: 1,
                }}
            />
            {generateLabel([0, label])}
            {generateLabel([90, label])}
            {generateLabel([180, label])}
            {generateLabel([270, label])}
        </Box>
    )

}